module.exports = __webpack_public_path__ + "img/ic-nav-tuktuk--prev-circle-white.532232ee.svg";